import AdaptiveStore from 'ember-simple-auth/session-stores/adaptive';
import EphemeralStore from 'ember-simple-auth/session-stores/ephemeral';
import { isPreviewBoot } from 'tio-employee/utils/preview-handoff';

/** In memory for a preview frame (the hand-off, and any reload after it), so no grant and no other session reaches this origin's localStorage from it; the cast picks one concrete signature to extend. */
export function sessionStoreFor(pathname?: string) {
  return (isPreviewBoot(pathname) ? EphemeralStore : AdaptiveStore) as typeof AdaptiveStore;
}

export default class SessionStore extends sessionStoreFor() {}
